import React, { useState, useEffect, Fragment } from 'react'
import axiosClient from 'api/axiosClient';
import axios from 'axios';
import { updateBreadCrumbNews, updateMenuSelected } from 'redux/actions/menu'
import { useDispatch, useSelector } from 'react-redux'
import Breadcrumbs from 'components/BreadCrumbs/Breadcrumbs'
import { Container, Row, Col } from 'reactstrap'
import MediaLQDTU from './MediaLQDTU.js'
import ImageBackground from 'components/Headers/ImageBackground.js'
import { OLD_API_URL, IMAGE_BASE_URL } from 'utils/constants';
import Sidebar from 'components/Navbars/Sidebar';
import { Link } from 'react-router-dom';
import { toDateTimeStringEnglish } from 'utils/utils';
import Loader from "react-loader-spinner";

export default function Media() {
    const [infoBanner, setinfoBanner] = React.useState([])
    const dispatch = useDispatch()
    
    // Logic from StudentContest
    const id = 'robocon'; // Default to robocon for the main student page
    const [loaded, setLoaded] = useState(false)
    const [posts, setAllPosts] = useState([]);

    const dataMenu1 = {
        "count": 4,
        "rows": [
            { "id": 1, "name": "Robocon", "seq": 0, "type": "robocon" },
            { "id": 2, "name": "Olympiad", "seq": 1, "type": "olympiad" },
            { "id": 3, "name": "Information Security", "seq": 2, "type": "information-security" },
            { "id": 4, "name": "Others", "seq": 3, "type": "others" },
        ]
    }

    const standardAlbum = (dataMenu) => {
        let menu = {
            id: 1,
            title: 'Students', // Changed from 'Student Contest' to match translation key
            type: "INCLUDE",
            path: '/student',
            children: []
        }
        if (dataMenu1.count > 0) {
            dataMenu1.rows.map((item) => {
                let menuItem = {
                    id: item.id,
                    type: 'CUSTOM_MEDIA',
                    title: item.name,
                    path: `/careerAndContest/contest/${item.type}`
                }
                menu.children.push(menuItem)
            })
        }
        return menu
    }

    const getPostData = (data, flag) => {
        return (
            !flag ? <Loader type="ThreeDots" color="var(--primary-color)" height="100" width="100" /> :
                <div className="news-all">
                    {data.map((item) => (
                        <div className="news-block" key={item.id}>
                            <div className="left-img">
                                <Link to={`/categorydetail/detail/${item.id}/contest`}>
                                    <img src={`${IMAGE_BASE_URL}/${item.avatar}`} alt="info image" />
                                </Link>
                            </div>
                            <div className="content">
                                <Link to={`/categorydetail/detail/${item.id}/contest`}>
                                    <div className="news-title">{item.title}</div>
                                </Link>
                                <div className="news-date">{toDateTimeStringEnglish(item.date)}</div>
                                <div className="news-summary">{item.short_description}</div>
                            </div>
                        </div>
                    ))}
                </div>
        )
    }

    useEffect(() => {
        // update breadcrumbs
        const menuArr = [
            { title: "Home", path: `/` },
            { title: 'Students', path: "" }
        ]
        dispatch(updateBreadCrumbNews(menuArr))
    }, [dispatch])

    useEffect(() => {
        const requestUrlBanner = `${OLD_API_URL}/banner?type=Menu&unit=home&menu=students`
        axios.get(requestUrlBanner).then(response => {
            setinfoBanner(response.data)
        }).catch(error => {
            console.error("Lỗi gọi API banner!", error)
        })
    }, [])

    useEffect(() => {
        setLoaded(false)
        const album = standardAlbum(dataMenu1)
        let temp = {
            id: "",
            type: 'CUSTOM_MEDIA',
            title: "",
            path: '#'
        }
        dataMenu1.rows.map((item) => {
            if (item.type === id) {
                temp = {
                    id: item.id,
                    type: 'CUSTOM_MEDIA',
                    title: item.name,
                    path: `/careerAndContest/contest/${item.type}`
                }
            }
        })

        dispatch(updateMenuSelected(album, temp, []))
        axiosClient.get(`/careerAndContest/contest/${id}?unit=home`).then(res => {
            const data = res.data;
            let flag = !!res;
            setAllPosts(getPostData(data, flag))
            setLoaded(true)
        }).catch(error => {
            console.error("Lỗi gọi API contest!", error)
            setLoaded(true)
        })
    }, [id])

    return (
        <Fragment>
            <ImageBackground height={500} imgSrc={infoBanner} />
            
            {/* Old Student Page Layout */}
            {/* 
            <Container className="wp-media">
                <Row>
                    <Col md={12}>
                        <Breadcrumbs></Breadcrumbs>
                        <MediaLQDTU></MediaLQDTU>
                    </Col>
                </Row>
            </Container>
            */}

            {/* New Student Page Layout matching Student Contest */}
            <div style={{ backgroundColor: '#fff', minHeight: '600px' }}>
                <Container>
                    <Row className="wp-rowCustompage">
                        <Col md={9} sm={12} className="wp-custompage">
                            <Breadcrumbs />
                            <div className="d-sidebar-none">
                                <Sidebar />
                            </div>
                            {!loaded ? (
                                <Loader type="ThreeDots" color="var(--primary-color)" height="100" width="100" />
                            ) : (
                                <div className="main-app">
                                    {posts}
                                </div>
                            )}
                        </Col>
                        <Col md={3} sm={12} className="">
                            <Sidebar />
                        </Col>
                    </Row>
                </Container>
            </div>
        </Fragment>
    )
}
